import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { Container } from '@sm/wds-react';
import { HomeBottomCard } from '../HomeBottomCard';
import audienceImage from '../assets/Audience.png';
import buildingsImage from '../assets/Buildings.png';

const COPY = defineMessages({
  HEADLINE_MARKET_RESEARCH: {
    id: 'CustomerExperienceCard.headlineMarketResearch',
    defaultMessage: 'Buy responses for your market research surveys',
    description:
      '[Type: Paragraph][Vis.: low] - Home bottom card market research headline',
  },
  MESSAGE_MARKET_RESEARCH: {
    id: 'CustomerExperienceCard.messageMarketResearch',
    defaultMessage: 'Find people to take your survey at an affordable price.',
    description:
      '[Type: Paragraph][Vis.: low] - Home bottom card market research message',
  },
  CTA_TEXT_MARKET_RESEARCH: {
    id: 'CustomerExperienceCard.ctaTextMarketResearch',
    defaultMessage: 'See pricing',
    description:
      '[Type: Button][Vis.: low] - Home bottom card market research cta text',
  },
  HEADLINE_NPS: {
    id: 'CustomerExperienceCard.headlineNPS',
    defaultMessage: 'See the "why" behind your Net Promoter Score®',
    description:
      '[Type: Paragraph][Vis.: low] - Customer experience card NPS headline',
  },
  MESSAGE_NPS: {
    id: 'CustomerExperienceCard.messageNPS',
    defaultMessage:
      'A turn-key NPS® solution to collect, understand, and act on customer feedback.',
    description:
      '[Type: Paragraph][Vis.: low] - Customer experience card NPS message',
  },
  CTA_TEXT_NPS: {
    id: 'CustomerExperienceCard.ctaTextNPS',
    defaultMessage: 'Visit CS site',
    description:
      '[Type: Button][Vis.: low] - Customer experience card NPS cta text',
  },
});

export const CustomerExperienceCard: React.FC = () => {
  return (
    <Container flex flexJustify="between">
      <HomeBottomCard
        headline={t(COPY.HEADLINE_MARKET_RESEARCH)}
        message={t(COPY.MESSAGE_MARKET_RESEARCH)}
        image={() => (
          <img
            src={audienceImage}
            width={60}
            height="auto"
            aria-hidden="true"
          />
        )}
        ctaText={t(COPY.CTA_TEXT_MARKET_RESEARCH)}
        ctaLink={createURL('/collect/audience/calculator/preview/', {
          ut_source: 'ucs',
          ut_source2: 'li_home',
          ut_source3: 'affordable-market-research-left',
          cvosrc: 'product.surveymonkey',
          cvo_campaign: 'li_home',
        })}
        ctaNewTab={true}
      />
      <HomeBottomCard
        headline={t(COPY.HEADLINE_NPS)}
        message={t(COPY.MESSAGE_NPS)}
        image={() => (
          <img
            src={buildingsImage}
            width={50}
            height="auto"
            aria-hidden="true"
          />
        )}
        ctaText={t(COPY.CTA_TEXT_NPS)}
        ctaLink={createURL('https://cx.surveymonkey.com/learn-more/', {
          ut_source: 'ucs',
          ut_source2: 'li_home',
          ut_source3: 'why-behind-nps-right',
          utm_source: 'surveymonkey',
          utm_medium: 'product',
          utm_content: 'cx-home',
          utm_term: 'visit-cx-site',
          utm_campaign: 'li_home',
          adid: 'li_home',
          family: 'CX',
          date: '2017-02-21',
          program: '701700000019SHlAAM',
          source: 'SurveyMonkey',
          recent: 'SurveyMonkey',
          cvosrc: 'product.surveymonkey',
          cvo_campaign: '701700000019SHlAAM',
          cvo_cid: 'li_home',
        })}
        ctaNewTab={true}
      />
    </Container>
  );
};

export default CustomerExperienceCard;
